import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-800 text-background-50">
      <div className="w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold">爆料吃瓜</span>
            </div>
            <p className="mt-4 max-w-xs font-body text-sm leading-relaxed text-secondary-100">
              爆料吃瓜现场直击，把零散的线索整理成清晰的时间线，全程围观最新进展，看热闹不迷路。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">热门分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="font-label text-sm text-secondary-100 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="font-label text-sm text-secondary-100 transition-colors hover:text-accent-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="font-label text-sm text-secondary-100 transition-colors hover:text-accent-300">
                  最新爆料
                </Link>
              </li>
              <li>
                <Link to="/about" className="font-label text-sm text-secondary-100 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/submit" className="font-label text-sm text-secondary-100 transition-colors hover:text-accent-300">
                  我要爆料
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">联系与投稿</h3>
            <ul className="mt-4 space-y-2.5 font-label text-sm text-secondary-100">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base text-accent-300"></i>
                <span>baoliao@chigua-site.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-base text-accent-300"></i>
                <span>内容更新：每日 09:00 - 24:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-base text-accent-300"></i>
                <span>线索核实后再发布</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-700 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-secondary-200">
            © 2026 爆料吃瓜 · 本站内容为公开信息整理，人物均使用代称
          </p>
          <p className="font-label text-xs text-secondary-200">
            温馨提示：理性吃瓜，不传谣、不信谣
          </p>
        </div>
      </div>
    </footer>
  );
}